import { formatNumber } from '@local_modules/flokit'
import { valueFormatter } from '../utils/value-formatter.js'

export function makeLocalAmountColumns (context) {
  const columnDefs = []

  columnDefs.push({
    headerName: 'Entity Amount',
    valueGetter: function (cellParams) {
      if (cellParams.data.type === 'break') return null
      if (cellParams.data.type === 'dateGroup') return null
      if (cellParams.data.type === 'entityPair') return null

      const signMultiplier = context.menuOptions.optionMultiplier.selectedOption().value === 'debitPositive' ? 1 : -1

      return cellParams.data.transaction?.ledger_amount * signMultiplier
    },
    valueFormatter,
    cellRenderer: function (cellParams) {
      if (!cellParams.value) return

      const currencyCode = cellParams.data.transaction?._in_currency_code

      return `<span class="tag is-info is-light is-small">${currencyCode}</span> ${formatNumber(cellParams.value, 2)}`
    },
    type: 'numericColumn'
  })

  return columnDefs
}
